/* eslint-disable */
import { UserRolesCanAssignRoleItem, fixUserRolesCanAssignRoleItemFromJson, fixUserRolesCanAssignRoleItemToJson } from '../dto/user-roles-can-assign-role-item';

export interface UserRolesCanAssignResponseDto {
  items: UserRolesCanAssignRoleItem[];
}

export const fixUserRolesCanAssignResponseDtoFromJson = (dto?: UserRolesCanAssignResponseDto | null): void => {
  if (!dto) {
    return;
  }
  dto.items?.forEach((x, i, a) => fixUserRolesCanAssignRoleItemFromJson(a[i]));
};

export const fixUserRolesCanAssignResponseDtoToJson = (dto?: UserRolesCanAssignResponseDto | null): void => {
  if (!dto) {
    return;
  }
  dto.items?.forEach((x, i, a) => fixUserRolesCanAssignRoleItemToJson(a[i]));
};
